<template>
  <div style="display: inline-flex" v-show="showButton">
    <slot :open="openPACS" :loading="loading"></slot>
    <PDFDialog title="Imagens em PDF" ref="pdfDialog" />
  </div>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
import { mapState } from 'vuex'
import PDFDialog from '@/components/PDFDialog'
export default {
  name: 'PacsButton',
  components: { PDFDialog },
  computed: {
    ...mapState({
      portalExamsWithoutPACSWarn: state =>
        state.data.organization.portal_exams_without_pacs_warn,
      portalExamsWithoutPACS: state =>
        state.data.organization.portal_exams_without_pacs,
    }),

    showButton() {
      if (this.portalExamsWithoutPACS === 'dont_show_pacs' && !this.hasImages)
        return false

      return true
    },
  },

  props: {
    hasImages: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    openPACS(exam, isPDF = false) {
      if (this.portalExamsWithoutPACS === 'warn' && !exam.imagem_pacs) {
        this.$toast.show(this.portalExamsWithoutPACSWarn, 'warn')
        return
      }
      if (this.loading) {
        this.$toast.show('PACS carregando ...', 'warn')
        return
      }

      this.loading = true

      const params = {
        pad_isn: this.$hashids.encode(exam.pad_isn),
        pac_cod: exam.pac_cod,
        emp_sigla: exam.emp_sigla,
        pex_data: exam.pex_data,
        sgr_codmoddicom: exam.sgr_codmoddicom,
        emp_cod: exam.ate_emp_cod,
        pac_datanasc: exam.pac_datanasc,
        pac_nome: exam.pac_nome,
      }

      const pacsRequest = isPDF ? Api.pacsPDF(params) : Api.pacs(params)
      pacsRequest
        .then(response => {
          const url = response.data.url
          if (url !== null && url !== '' && url !== undefined) {
            if (isPDF) {
              this.$refs.pdfDialog.open(url)
            } else {
              const windowReference = window.open()
              windowReference.location = response.data.url
            }
          } else {
            this.$toast.show('PACS - URL inválida', 'error')
          }
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar PACS', 'error')
          throw error
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
